<template>
  <div>
    <h1>Catalogue des Références (Boucle interne)</h1>
    <b-row id="toptab">
      <b-col md="4">
        <b-form-group horizontal label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Rechercher" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Effacer</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
       <b-col md="2" offset-md="2">
        <b-form-group horizontal label="Emplacement" class="mb-0">
          <b-input-group>
            <b-form-input v-model="positionFilter" @input="searchEmplacement" placeholder="Rechercher un emplacement" />
            <b-input-group-append>
              <b-btn :disabled="!positionFilter" @click="positionFilter = null">Effacer</b-btn>
            </b-input-group-append>
          </b-input-group>
          </b-form-group>
      </b-col>
       <b-col md="2" offset-md="1" class="mb-0">
        <b-button size="sm" variant="outline-primary" @click="addNewReference()">Ajout d'une référence</b-button>
      </b-col>
    </b-row>
    <b-row style="margin-top: 3%">
      <b-col md="4" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
        />
      </b-col>
    </b-row>
    <b-table
      id="my-table"
      ref="table"
      :bordered="bordered"
      :outlined="outlined"
      :busy.sync="isBusy"
      :items="getReferencesAsync"
      :fields="fields"
      :filter="filter"
      filter-debounce="400"
      :current-page="currentPage"
      :per-page="perPage"
    >
      <div slot="table-busy" class="text-center text-danger my-2">
        <!-- <b-spinner class="align-middle"></b-spinner> -->
        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
      <template v-slot:cell(loops)="row">
        <b-badge variant="info" v-for="loop in row.item.loops" :key="loop">
          {{ loop }}
        </b-badge>
      </template>
      <template v-slot:cell(detail)="row">
        <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
        <b-button size="sm" @click="showDetail(row)" class="mr-2">
          {{ row.showDetail ? 'Cacher' : 'Afficher' }} le détail
        </b-button>
        <br />
        <b-button
          size="sm"
          style="font-size: 12px; margin-left: 10px"
          @click="goTo('/andon_internal/' + row.item.reference.code)"
          class="mr-2"
          variant="outline-primary"
        >
          Hippodrome
        </b-button>
      </template>
      <template v-slot:row-details="row">
        <b-button size="sm" @click="recomputeCards(row)" class="mr-2"
          >Recalculer les cartes</b-button
        >
        <b-button size="sm" @click="printAllCards(detailsItems)" class="mr-2"
          >Imprimer les cartes</b-button
        >
        <b-button size="sm" @click="printFlowrackTicket(row)" class="mr-2"
          >Imprimer ticket flowrack</b-button
        >
        <!-- <b-button size="sm" @click="displayModalTmpCards(row)" class="mr-2"
          >Créer cartes temporaires</b-button
        > -->
        <b-card>
          <b-table striped hover :items="detailsItems" :fields="detailsFields">
            <template v-slot:cell(last_print_at)="row">
              <div>
                {{
                  row.item.last_print_at == null
                    ? '--'
                    : row.item.last_print_at | moment('DD-MM-YYYY')
                }}
              </div>
            </template>
            <template v-slot:cell(supplier)="row">
                <div>
                 {{ row.item.supplier == null ? '--' : row.item.supplier.supplier }}
                </div>
            </template>
            <template v-slot:cell(Imprimer)="row">
              <div>
                <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
                <b-button
                  size="sm"
                  variant="primary"
                  @click="printCard(row)"
                  class="mr-2"
                >
                  <i class="fa fa-print" aria-hidden="true"></i>
                </b-button>
              </div>
            </template>
            <template v-slot:cell(Update)="row">
              <div>
                <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
                <b-button
                  size="sm"
                  variant="primary"
                  @click="goToUpdateCardInfos(row)"
                  class="mr-2"
                >
                  <i class="fa fa-refresh" aria-hidden="true"></i>
                </b-button>
              </div>
            </template>
          </b-table>
          <b-button size="sm" @click="showDetail(row)"
            >Cacher le détail</b-button
          >
        </b-card>
      </template>
      <template v-slot:cell(seconds_since_last_scan)="row">
        <p>{{ row.item.seconds_since_last_scan }} J</p>
      </template>
      <template v-slot:cell(update)="row">
        <div>
          <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
          <b-button
            size="sm"
            variant="primary"
            :disabled="needsToBeDisabled(row)"
            @click="goToAddNewReference(row)"
            class="mr-2"
          >
            <i class="fa fa-refresh" aria-hidden="true"></i>
          </b-button>
        </div>
      </template>
      <template v-slot:cell(disable)="row">
        <div>
          <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
          <b-button
            size="sm"
            variant="danger"
            :disabled="needsToBeDisabled(row)"
            @click="disable(row)"
            class="mr-2"
          >
            <i class="fa fa-trash" aria-hidden="true"></i>
          </b-button>
        </div>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          v-model="currentPage"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import server from '../../api/server.vue'
import referenceApi from '../../api/reference.vue'
import { mapGetters } from 'vuex'
import printHeureServer from '../../api/printHeureServer.vue'

export default {
  name: 'InternalLoopRefList',
  data() {
    return {
      currentPage: 1,
      previousRowDetailed: null,
      totalRows: 0,
      isBusy: false,
      filter: null,
      positionFilter: null,
      actualCtx: '',
      perPage: 20,
      bordered: true,
      outlined: true,
      tmpCardForm: {reference: '', qty: 0, loop: 'loop_external', supplier: ''},
      detailsFields: [
        { key: 'card_id', sortable: true },
        { key: 'card_index', sortable: true },
        // { key: 'removed', sortable: true },
        {
          key: 'seconds_since_last_scan',
          label: 'Jours depuis le dernier scan',
          sortable: true
        },
        {
          key: 'last_print_at',
          label: 'Carte imprimée le',
          sortable: true
        },
        { key: 'supplier', label: 'Fournisseur', sortable: true },
        'Imprimer',
        'Update'
      ],
      fields: [
        { key: 'reference.code_display', label: 'Code', sortable: true },
        { key: 'nbr_card', sortable: true },
        { key: 'batch_size', sortable: true },
        { key: 'reference.designation', label: 'Designation', sortable: true },
        { key: 'weight', label: 'Poids', sortable: true },
        {
          key: 'reference.supermarket_emplacement',
          label: 'Emplacement',
          sortable: true
        },
        { key: 'destination', sortable: true },
        'Detail',
        'update',
        'disable'
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedCode'])
  },
  methods: {
    showDetail(row) {
      server
        .getKanbanCardByReference(
          row.item.reference.code,
          'loop_usual_components'
        )
        .then(response => {
          this.detailsItems = response.data
          this.totalDetailsRows = this.detailsItems.length
          if (
            this.previousRowDetailed &&
            row.item.reference.code != this.previousRowDetailed.item.code
          ) {
            this.previousRowDetailed.toggleDetails()
          }
          // this.previousRowDetailed = row
          row.toggleDetails()
          //_cellVariants: { isActive: 'success', age: 'info', first_name: 'warning' }
        })
    },
    displayModalTmpCards(row) {
      this.selectedRow = row
      this.tmpCardForm.supplier = row.item.supplier ? row.item.supplier : '--'
      this.displayTmpCardModal = true
      this.tmpCardForm.reference = row.item.reference.code
    },
    needsToBeDisabled(row) {
      return row.item.removed === 'Supprimé'
    },
    disable(row) {
      referenceApi.removeReference(row.item.reference.code).then(result => {
        row.item.removed = 'Supprimé'
        row.item.loops = []
      })
    },
    goToAddNewReference(row) {
      this.$store.commit('setActualLoop', 'loop_internal')
      this.goTo('/references/new/' + row.item.reference.code)
    },
    goToUpdateCardInfos(row) {
      this.$store.commit('setActualLoop', row.item.kanban_reference.loop)
      this.goTo('/update_card_infos/' + row.item.kanban_reference.reference.code)
    },
    recomputeCards(row) {
      server
        .recalculateCardsByKanbanRef(
          row.item.reference.code,
          row.item.nbr_card,
          'loop_usual_components'
        )
        .then(result => {
          this.showDetail(row)
        })
    },
    getPrintData(element) {
      return [{
        EMPLACEMENT: element.kanban_reference.reference.supermarket_emplacement,
        REFERENCE: this.chunk(element.kanban_reference.reference.code, 3),
        LIVRAISON: element.kanban_reference.destination == null ? '--' : element.kanban_reference.destination,
        FOURNISSEUR: element.supplier == null ? '--' : element.supplier.supplier,
        REF_FOURNISSEUR: element.supplier == null ? '--' : element.supplier.supplier_id,
        CARD_ID: element.card_id,
        DESIGNATION: element.kanban_reference.reference.designation,
        POIDS: element.kanban_reference.reference.weight,
        TAILLE_LOT: element.kanban_reference.batch_size,
        NUM_CARTE: element.card_index,
        NB_CARTE: element.kanban_reference.nbr_card
      }]
    },
    printCard(row) {
      printHeureServer.printCard(this.getPrintData(row.item), 'KANBAN_SUPPLY_CHAIN_INTERNAL.lbx')
        .then(() => {
          this.makeToast('Impression en cours...')
          this.updateLastPrint(row.item.card_id)
        }).catch((e) => console.error(e))
    },
    updateLastPrint (card_id) {
      server.updateLastPrintCard(card_id).then(() => {
      })
    },
    printAllCards(detailsItems) {
      let data = []
      detailsItems.forEach(element => {
        data.push(this.getPrintData(element))
      })
      printHeureServer.printCard(data, 'KANBAN_SUPPLY_CHAIN_INTERNAL.lbx').then(() => {
        this.makeToast(`Impression de ${detailsItems.length} cartes en cours...`)
        detailsItems.forEach(card => this.updateLastPrint(card.card_id))
      })
    },
    printFlowrackTicket(row) {
      let data = [
        {
          REFERENCE: this.chunk(row.item.reference.code, 3),
          DESIGNATION: row.item.reference.designation,
          BARCODE:
            row.item.reference.code +
            '-' +
            row.item.reference.supermarket_emplacement
        }
      ]
      printHeureServer.printFlowrack(data).then(() => {
        this.makeToast('Impression en cours...')
      })
    },
    addNewReference() {
      this.$store.commit('setSelectedCode', '')
      this.$store.commit('setActualLoop', 'loop_internal')
      this.goTo('/references/new/')
    },
    sageDbEmplacementMismatch(row) {
      return row.item.andon !== ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    makeToast(result, append = false) {
      let toast = this.$toasted.success(result + ' mis à jour', {
        theme: 'bubble',
        position: 'top-right',
        duration: 5000
      })
    },
    forceRefresh() {
      this.getReferencesAsync(this.actualCtx).then(result => {
        this.$refs.table.refresh()
      })
    },
    getReferencesAsync(ctx) {
      ctx = {...ctx,keep_only_lead_time:this.keep_only_lead_time}
      if (this.positionFilter) {
        ctx = {...ctx, search_by_emplacement: this.positionFilter}
      }
      return referenceApi.getFilteredReferencesInternal(ctx).then(response => {
        var data = response.data.references
        var formatedResult = []
        this.totalRows = response.data.total_references
        for (var i = 0; i < data.length ; i++) {
          if (data[i]['removed']) {
            data[i]['removed'] = 'Supprimé'
            data[i]['isActive'] = false
          } else {
            data[i]['removed'] = ''
          }
          data[i]['reference']['code_display'] = this.chunk(data[i]['reference']['code'], 3)
          data[i]['emplacement'] =
            data[i]['reference']['zone'] +
            data[i]['reference']['pos_y'] +
            ('0' + data[i]['reference']['pos_x']).slice(-2) +
            data[i]['reference']['pos_z']
          if (typeof(data[i]['reference']['lead_time']) === 'number') {
            data[i]['reference']['lead_time'] = (data[i]['reference']['lead_time'] / 3600 / 24).toFixed(1) + " J"
          }
          formatedResult.push(data[i])
        }
        this.actualCtx = ctx
        return formatedResult
      })
    },
    searchEmplacement() {
      this.getReferencesAsync(this.actualCtx).then(() => {
        this.$refs.table.refresh()
        this.currentPage = 1
      })
    }
  },
  mounted: function () {
    if (!_.isEmpty(this.selectedCode)) {
      this.filter = this.selectedCode
      this.$store.commit('setSelectedCode', '')
    }
  },
  watch: {
    filter: function (val) {
      if (this.filter) {
        this.$router.push({
          name: 'internal_references',
          params: { filter: val }
        })
      }
    }
  },
  beforeMount: function () {
    this.filter = this.$route.params.filter
  },
  components: {
  }
}
</script>


<style type="text/css" scoped>
.btn {
  margin-left: 0px !important;
  margin-top: 2px !important;
}
#toptab {
  margin-top: 3%;
}
</style>


// WEBPACK FOOTER //
// src/components/supply/InternalLoopRefList.vue